'use client'

import React from 'react'

import { Button } from '@/components/ui/button'

export default function Error({ reset }: { reset: () => void }) {
  return (
    <div className="container flex flex-col items-center gap-6 py-24 text-center md:py-32">
      <div className="flex flex-col gap-3">
        <p className="font-display text-2xl text-ink md:text-3xl">Что-то пошло не так</p>
        <p className="max-w-md text-ink/60">
          Страница не загрузилась. Часто это разовая заминка — попробуйте ещё раз.
        </p>
      </div>
      <Button onClick={() => reset()} type="button">
        Попробовать снова
      </Button>
    </div>
  )
}
